import './App.css';
import Home from './Components/Home';
import Header from './Components/Header';
import FooterComponent from './Components/Footer';
import About from './Components/About';
import Product_page from './Components/Product_page';
import Contact from './Components/Contact';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';



function App() {
  return (


    <Router>
      <Header />
      <div className="App bg-yellow-50">
        <Routes>

          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path='/product_page' element={<Product_page />} />
          <Route path='/Contact' element={<Contact />} />

        </Routes>

      </div>
      <FooterComponent />
    </Router>

  );
}

export default App;
